import { STATUS_MAP_DEFAULT, onResolveStatus } from './_statusMap';

const BLOCK = 'LStudio__app_status';

/*
    🔥 PASTILLA DE ESTADO

    Recibe el valor crudo del backend y lo traduce a color + texto
    usando el mapa. La vista nunca decide colores: solo pasa el dato.

        <StatusBadge status={row.estado} />
        <StatusBadge status={row.estado} map={STATUS_PEDIDOS} />

    ⚠️ EL PUNTO NO ES DECORACIÓN

    El color solo no alcanza: entre 8% y 10% de los varones no
    distingue rojo de verde. El punto le da forma al estado y el texto
    siempre está presente, así que la pastilla se entiende en escala
    de grises y la lee un lector de pantalla.
*/

export const StatusBadge = ({
    status,
    map = STATUS_MAP_DEFAULT,
    variant = 'soft',            // soft | solid | outline | text
    size = 'md',                 // sm | md | lg
    showDot = true,
    fallbackTone = 'neutral',
    label = null,                // pisa el label del mapa si hace falta
}) => {

    const RESOLVED = onResolveStatus(status, map, fallbackTone);

    return (
        <span
            className={BLOCK}
            data-tone={RESOLVED.tone}
            data-variant={variant}
            data-size={size}
            data-unknown={!RESOLVED.isKnown}
            title={RESOLVED.isKnown ? undefined : `Estado sin mapear: ${RESOLVED.key}`}
        >

            {showDot && <span className={`${BLOCK}__dot`} aria-hidden="true" />}

            <span className={`${BLOCK}__label`}>{label ?? RESOLVED.label}</span>

        </span>
    );
};
